export const mapOAuthParametersDatum = (datum) => {
  if (!datum) return;
  const { base_url, parameters } = datum.components;
  return {
    baseUrl: base_url,
    parameters: parameters,
  };
};
